module.exports = __webpack_public_path__ + "img/竖向中线对齐.9ccb6490.svg";